export default function convertToCurrency(
  locale?: string,
  currency = 'usd',
  price?: number | null,
  numberOfDecimals = 2
) {
  if (!price) {
    return '-'
  }
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: numberOfDecimals,
    minimumFractionDigits: numberOfDecimals,
  }).format(price / 100)
}
